import { DocumentNode, gql } from '@apollo/client';
import { useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { LogInSignUpModal } from '@/components/LogInSignUp';
import { ERsvpResponse } from '@/graphql-types/globalTypes';
import { useCurrent } from '@/hooks/useCurrent';

import { RsvpMenu_EventFragment } from './graphql-types/RsvpMenu_EventFragment';

import { RsvpSelect } from './components/RsvpSelect';
import { useRsvpMenu } from './hooks/useRsvpMenu';

export const RsvpMenu: React.FC<{
  event: RsvpMenu_EventFragment;
  isDisabled?: boolean;
}> & { eventFragment: DocumentNode } = ({ event, isDisabled }) => {
  const current = useCurrent();
  const loginDisclosure = useDisclosure();
  const { isLoading, createRsvpForEvent, updateRsvpResponse } = useRsvpMenu();

  const currentUserRsvp =
    event.__typename === 'SimpleEventV2' && event.currentUserRsvp
      ? event.currentUserRsvp
      : undefined;

  const handleRsvpChange = async (rsvpResponse: ERsvpResponse) => {
    if (!current.user) {
      return loginDisclosure.onOpen();
    }

    if (currentUserRsvp) {
      updateRsvpResponse({
        variables: {
          input: {
            id: currentUserRsvp._id,
            response: rsvpResponse,
          },
        },
      });
    } else {
      createRsvpForEvent({
        variables: {
          input: {
            attendeeId: current.user._id,
            eventId: event._id,
            response: rsvpResponse,
          },
        },
      });
    }
  };

  return (
    <>
      <LogInSignUpModal
        isOpen={loginDisclosure.isOpen}
        onClose={loginDisclosure.onClose}
      />

      <RsvpSelect
        value={currentUserRsvp ? currentUserRsvp.response : undefined}
        onChange={handleRsvpChange}
        isLoading={isLoading}
        isDisabled={isDisabled}
      />
    </>
  );
};

RsvpMenu.eventFragment = gql`
  fragment RsvpMenu_EventFragment on EventV2 {
    _id
    ... on SimpleEventV2 {
      currentUserRsvp {
        _id
        response
      }
    }
  }
`;
